import { clientLoadMore } from '../util/loadMore';

export default {
  init() {
    const loadMoreRelatedContentBtn = document.getElementById('js-load-more-related');
    if (loadMoreRelatedContentBtn) {
      loadMoreRelatedContentBtn.addEventListener('click', () => {
        clientLoadMore({ button: loadMoreRelatedContentBtn, increment: 3, listId: 'js-results-related' });
      });
    }
    const loadMoreRepresentantsBtn = document.getElementById('js-soft-load-more-representants');
    if (loadMoreRepresentantsBtn) {
      loadMoreRepresentantsBtn.addEventListener('click', () => {
        clientLoadMore({ button: loadMoreRepresentantsBtn, increment: 4, listId: 'js-results-representants' });
      });
    }

    const selecteur = document.getElementById('selecteur-numero');
    selecteur.addEventListener('change', (e) => {
      const url = window.location.origin + window.location.pathname;
      const queryParam = `?numero=${e.target.value}`;
      window.location.href = url + queryParam;
    });
    
  },
};
